"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _axios = _interopRequireDefault(require("axios"));
var _clipboard = _interopRequireDefault(require("@/utils/clipboard"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import clipboard from '@/directive/clipboard/index.js' // use clipboard by v-directive
// use clipboard directly
var _default = exports.default = {
  name: 'UserClassification',
  // directives: {
  //   clipboard
  // },
  data: function data() {
    var _this = this;
    var validateClfName = function validateClfName(rule, value, callback) {
      if (!value || value.length > 100) {
        callback(new Error(_this.$t('userClassification.error.clfName')));
      } else if (_this.errorKeys.indexOf('clfName') >= 0) {
        callback(new Error(_this.errorInfo['clfName']));
        _this.resetError('clfName');
      } else {
        callback();
      }
    };
    var validateClfCode = function validateClfCode(rule, value, callback) {
      if (!value || value.length > 100) {
        callback(new Error(_this.$t('userClassification.error.clfCode')));
      } else if (_this.errorKeys.indexOf('clfCode') >= 0) {
        callback(new Error(_this.errorInfo['clfCode']));
        _this.resetError('clfCode');
      } else {
        callback();
      }
    };
    var validateDpExecutor = function validateDpExecutor(rule, value, callback) {
      if (!value || value.length > 100) {
        callback(new Error(_this.$t('userClassification.error.dpExecutor')));
      } else if (_this.errorKeys.indexOf('dpExecutor') >= 0) {
        callback(new Error(_this.errorInfo['dpExecutor']));
        _this.resetError('dpExecutor');
      } else {
        callback();
      }
    };
    return {
      formLabelWidth: '120px',
      loadingComponent: null,
      listLoading: false,
      isLoading: false,
      list: [],
      total: 0,
      currentId: null,
      isShowModel: false,
      currPage: 1,
      limit: 10,
      sourceApi: null,
      searchVal: {
        clfName: '',
        clfCode: '',
        dpExecutor: '',
        dpContent: '',
        remark: ''
      },
      dialogStatus: 'create',
      form: {
        clfName: '',
        clfCode: '',
        dpExecutor: '',
        dpContent: '',
        remark: ''
      },
      initForm: {
        clfName: '',
        clfCode: '',
        dpExecutor: '',
        dpContent: '',
        remark: ''
      },
      rules: {
        clfName: [{
          required: true,
          trigger: ['change'],
          validator: validateClfName
        }],
        clfCode: [{
          required: true,
          trigger: ['change'],
          validator: validateClfCode
        }],
        dpExecutor: [{
          required: true,
          trigger: ['change'],
          validator: validateDpExecutor
        }],
        dpContent: [{
          required: true,
          trigger: ['change'],
          message: this.$t('userClassification.error.dpContent')
        }],
        remark: [{
          required: false,
          trigger: ['change'],
          message: this.$t('userClassification.error.remark')
        }]
      },
      errorKeys: [],
      errorInfo: {}
    };
  },
  watch: {
    isLoading: function isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0)'
        });
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close();
        }
      }
    }
  },
  mounted: function mounted() {
    this.fetchData();
  },
  methods: {
    tableIndex: function tableIndex(index) {
      return index + 1;
    },
    fetchData: function fetchData() {
      var _this2 = this;
      if (this.sourceApi) {
        this.sourceApi.cancel('cancel');
      }
      this.sourceApi = _axios.default.CancelToken.source();
      var param = {
        currPage: this.currPage,
        limit: this.limit,
        smodel: (0, _objectSpread2.default)({}, this.searchVal)
      };
      this.listLoading = true;
      this.$api.userClassification.getUserClassificationList(param, this.sourceApi.token).then(function (res) {
        _this2.listLoading = false;
        _this2.list = res.data.items;
        _this2.total = res.data.totalCount;
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
        _this2.listLoading = false;
      });
    },
    searchData: function searchData() {
      this.currPage = 1;
      this.fetchData();
    },
    refreshData: function refreshData() {
      this.fetchData();
    },
    resetError: function resetError(val) {
      if (val) {
        var index = this.errorKeys.indexOf(val);
        this.errorKeys.splice(index, 1);
        delete this.errorInfo.val;
      } else {
        this.errorKeys = [];
        this.errorInfo = {};
      }
    },
    create: function create() {
      var _this3 = this;
      this.dialogStatus = 'create';
      this.form = {
        clfName: '',
        clfCode: '',
        dpExecutor: '',
        dpContent: '',
        remark: ''
      };
      this.initForm = {
        clfName: '',
        clfCode: '',
        dpExecutor: '',
        dpContent: '',
        remark: ''
      };
      this.isShowModel = true;
      this.$nextTick(function () {
        _this3.$refs['dataForm'].clearValidate();
      });
    },
    edit: function edit(row) {
      var _this4 = this;
      this.dialogStatus = 'edit';
      this.currentId = row.clfCode;
      if (this.currentId === null) {
        return;
      }
      this.getDetail().then(function (res) {
        _this4.isShowModel = true;
        _this4.$nextTick(function () {
          _this4.$refs['dataForm'].clearValidate();
        });
      });
    },
    getDetail: function getDetail() {
      var _this5 = this;
      return new Promise(function (resolve) {
        _this5.isLoading = true;
        _this5.$api.userClassification.getUserClassificationDetail(_this5.currentId).then(function (res) {
          _this5.isLoading = false;
          var _res$data = res.data,
            clfName = _res$data.clfName,
            clfCode = _res$data.clfCode,
            dpExecutor = _res$data.dpExecutor,
            dpContent = _res$data.dpContent,
            remark = _res$data.remark;
          _this5.form = {
            clfName: clfName,
            clfCode: clfCode,
            dpExecutor: dpExecutor,
            dpContent: dpContent,
            remark: remark
          };
          _this5.initForm = {
            clfName: clfName,
            clfCode: clfCode,
            dpExecutor: dpExecutor,
            dpContent: dpContent,
            remark: remark
          };
          resolve(_this5.form);
        }).catch(function () {
          console.log('Data Request Fail');
          _this5.isLoading = false;
        });
      });
    },
    deleteItem: function deleteItem(row) {
      var _this6 = this;
      this.$confirm(this.$t('common.confirm1'), this.$t('common.tip'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(function () {
        _this6.isLoading = true;
        _this6.$api.userClassification.deleteUserClassification([row.clfCode]).then(function (res) {
          _this6.isLoading = false;
          _this6.refreshData();
        }).catch(function () {
          _this6.isLoading = false;
        });
      }).catch(function () {});
    },
    saveItem: function saveItem() {
      var _this7 = this;
      this.$refs['dataForm'].clearValidate();
      this.$refs.dataForm.validate(function (valid) {
        if (!valid) return;
        _this7.isLoading = true;
        _this7.$api.userClassification.saveUserClassification(_this7.form).then(function (res) {
          _this7.isLoading = false;
          _this7.isShowModel = false;
          _this7.refreshData();
        }).catch(function (err) {
          if (err.errorInfos && err.errorInfos.length > 0) {
            _this7.resetError();
            err.errorInfos.forEach(function (item) {
              _this7.errorKeys.push(item.key);
              _this7.errorInfo[item.key] = item.errMsg;
            });
            _this7.$refs['dataForm'].validate();
          }
          _this7.isLoading = false;
        });
      });
    },
    celldblclick: function celldblclick(row, column, cell, event) {
      // const _this = this
      (0, _clipboard.default)(event.target.innerText, event);
    }
  }
};